import React, { useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import IeSignUpOptions from "../user/IeSignUpOptions";
import { breakpoints } from "../../utils/styles";
import BackButton from "../common/BackButton";
import { sortByName } from '../../utils/arrays';
import { getCinemas, getIeSignUpOptions } from "../../reducers";
import { fetchIeSignUpOptions } from "../../actions/creators/ie";
import BodyBlocker from "../BodyBlocker";

const Container = styled.div`
  background: var(--page-bg);
  bottom: ${(props) => (props.visible ? 0 : "-100%")};
  height: 98%;
  position: fixed;
  right: 0;
  width: 100%;
  overflow-y: auto;
  transition: bottom 0.5s ease-in-out, right 0.5s ease-in-out;
  z-index: 1050;

  @media screen and (min-width: ${breakpoints.tablet}px) {
    height: 100%;
    right: ${(props) => (props.visible ? 0 : "-66.67vw")};
    top: 0;
    width: 66.66vw;
  }
`;

const CinemaSelectBlock = styled.div`
  height: auto;
  opacity: 1;
  transition: opacity 0.5s ease-in;
  margin-bottom: 2.5rem;

  &.hidden {
    height: 0;
    opacity: 0;
    transition: opacity 0s ease-in;
  }
`;

const Head = styled.div`
  text-align: center;

  @media screen and (min-width: ${breakpoints.tablet}px) {
    text-align: left;
  }
`;

function SignUpManualIEOptions(props) {
  const [selectedCinemaId, setSelectedCinemaId] = useState(0);

  const handleCinemaChange = (event) => {
    // Reset selected level
    props.onIEOptionSelect(null);
    setSelectedCinemaId(event.target.value);
    props.onCinemaChange(event.target.value);
    props.fetchIeSignUpOptions({ cinemaId: event.target.value });
  };
    
  return <>
    {props.visible && <BodyBlocker />}
    <Container className="px-5 py-4" visible={props.visible}>
      <div className="mb-5">
        <BackButton
          onBackClick={props.close}
          label="Selecciona tu beneficio de bienvenida de Cinemex Loop"
        />
      </div>

      <Head>
        <p>
          Por favor <strong>selecciona tu cine preferido</strong> para ver las
          opciones:
        </p>

        <CinemaSelectBlock className="col-md-6 pl-0">
          <select
            className="form-control"
            id="preferencesCine"
            onChange={handleCinemaChange}
            value={selectedCinemaId}
          >
            <option key="0" value={0}>
              Selecciona tu cine
            </option>
            {props.cinemas.map((cinema) => (
              <option value={cinema.id} key={cinema.id}>
                {cinema.name}
              </option>
            ))}
          </select>
        </CinemaSelectBlock>

        <p className="mb-4">
          Recuerda que los boletos incluidos en el beneficio serán{" "}
          <strong>únicamente válidos en el cine seleccionado.</strong>
        </p>
      </Head>

      <IeSignUpOptions
        levels={props.levelOptions}
        onLevelSelect={props.onIEOptionSelect}
        hidePriceZero
        altStyles
      />
    </Container>
  </>;
}

const mapStateToProps = state => ({
  cinemas: getCinemas(state).sort(sortByName),
  levelOptions: getIeSignUpOptions(state),
});

const mapDispatchToProps = {
  fetchIeSignUpOptions,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpManualIEOptions));
